import React from "react";
import { ReactSVG } from "react-svg";

const CompanyLogo = ({ logoUrl }) => {
    if (!logoUrl) return null;

    const getFileType = (url = "") => {
        if (!url) return null;
        const cleanUrl = url.split("?")[0];
        return cleanUrl.split(".").pop().toLowerCase();
    };
    const fileType = getFileType(logoUrl);

    if (fileType === "svg") {
        return (
            <ReactSVG
                src={logoUrl}
                beforeInjection={(svg) => {
                    svg.setAttribute("style", "max-width:180px; height:auto;");
                }}
            />
        );
    }

    return (
        <img
            src={logoUrl}
            alt="Company Logo"
            style={{ maxWidth: 180 }}
            onError={(e) => {
                e.target.src = "/assets/images/default-logo.png";
            }}
        />
    );
};

export default CompanyLogo;